import React from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { verifyPhone } from "../utils/validators";
import CountrySelect from "./CountrySelect";

export default function JobReferencesFieldArray({ nestIndex, register, setValue, errors }) {
  const { fields, remove, append } = useFieldArray({
    name: `jobExperiences.${nestIndex}.jobReferencesData`,
  });

  if (fields.length === 0) {
    append({
      name: "",
      phone: "",
      jobPosition: "",
      city: "",
    });
  }

  const jobExperiences = useWatch({
    name: "jobExperiences",
  });

  return (
    <>
      <ul className="c-form__list">
        {fields?.map((reference, referenceIndex) => {
          return (
            <li key={`references.${referenceIndex}`} className="c-profile-info__section c-form__section">
              <div className="c-form__row c-form__row--2col">
                <label className="c-form__group c-form__col">
                  <span className="c-form__label">Nombre </span>
                  <input
                    type="text"
                    id="form-name"
                    name="name"
                    className="c-form__input"
                    placeholder="Ingresa el nombre"
                    {...register(`jobExperiences.${nestIndex}.jobReferencesData.${referenceIndex}.name`, {
                      required: true,
                    })}
                  />
                  {errors?.jobExperiences &&
                    errors.jobExperiences[nestIndex]?.jobReferencesData &&
                    errors?.jobExperiences[nestIndex]?.jobReferencesData[referenceIndex]?.name?.type === "required" && (
                      <span className="c-form__error">Este campo es obligatorio</span>
                    )}
                </label>
                <label className="c-form__group c-form__col">
                  <span className="c-form__label">Teléfono de contacto </span>
                  <input
                    type="tel"
                    id="form-phone"
                    name="phone"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    className="c-form__input"
                    placeholder="Ingresa el número de contacto"
                    {...register(`jobExperiences.${nestIndex}.jobReferencesData.${referenceIndex}.phone`, {
                      required: true,
                      validate: verifyPhone,
                    })}
                  />
                  {errors?.jobExperiences &&
                    errors.jobExperiences[nestIndex]?.jobReferencesData &&
                    errors?.jobExperiences[nestIndex]?.jobReferencesData[referenceIndex]?.phone?.type === "required" && (
                      <span className="c-form__error">Este campo es obligatorio</span>
                    )}
                  {errors?.jobExperiences &&
                    errors.jobExperiences[nestIndex]?.jobReferencesData &&
                    errors?.jobExperiences[nestIndex]?.jobReferencesData[referenceIndex]?.phone?.type === "validate" && (
                      <span className="c-form__error">El teléfono/celular no es válido</span>
                    )}
                </label>
              </div>
              <CountrySelect
                label="País de residencia"
                register={register}
                setValue={setValue}
                errors={errors}
                countryPath={`jobExperiences.${nestIndex}.jobReferencesData.${referenceIndex}.country`}
                otherCountryPath={`jobExperiences.${nestIndex}.jobReferencesData.${referenceIndex}.otherCountry`}
                cityPath={`jobExperiences.${nestIndex}.jobReferencesData.${referenceIndex}.city`}
                selectedCountry={
                  jobExperiences[nestIndex]?.jobReferencesData[referenceIndex]?.country
                }
              />
              <div className="c-form__right-aligner">
                <button
                  type="button"
                  onClick={() => remove(referenceIndex)}
                  className="c-form__btn c-form__btn-delete c-form__btn c-form__btn-delete--top u-tap-size"
                >
                  <span className="c-form__btn-icon icon-delete"></span>Eliminar referencia
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="c-form__right-aligner">
        <button
          type="button"
          onClick={() =>
            append({
              name: "",
              phone: "",
              jobPosition: "",
              city: "",
            })
          }
          className="c-form__btn-add u-tap-size"
        >
          <span className="c-form__btn-add-icon icon-more"></span>Añadir referencia
        </button>
      </div>
    </>
  );
}
